import { apiFetch } from "./client";

export async function analyzeRepairEstimate({ files, zipCode, captureMode = "quick", measurements = [], quantityDisclaimerAck = false }) {
  const form = new FormData();
  form.append("zip_code", String(zipCode || "").trim());
  form.append("capture_mode", captureMode);
  form.append("measurement_data", JSON.stringify(measurements));
  form.append("quantity_disclaimer_ack", String(Boolean(quantityDisclaimerAck)));
  Array.from(files || []).forEach((file) => form.append("photos", file, file.name));
  const response = await apiFetch("/repair-estimates/analyze", { method: "POST", body: form });
  return response.data;
}

export async function repriceRepairMaterial({ zipCode, material, materialQuantity, unit, currentMaterial, trade, description, repairQuantity, laborHours }) {
  const response = await apiFetch("/repair-estimates/reprice-material", {
    method: "POST",
    body: { zip_code: zipCode, material, material_quantity: materialQuantity, unit, current_material: currentMaterial, trade, description, repair_quantity: repairQuantity, labor_hours: laborHours },
  });
  return response.data;
}

export async function applyRepairClarifications({ zipCode, estimateResult, answers }) {
  const response = await apiFetch("/repair-estimates/apply-clarifications", {
    method: "POST",
    body: { zip_code: zipCode, estimate_result: estimateResult, answers },
  });
  return response.data;
}
